import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import { alpha, styled } from '@mui/material/styles';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import { KeyboardButtonProps } from './types';

export const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const KeyboardButton = styled(Button)<KeyboardButtonProps>(({ theme, buttonType = 'default' }) => {
  const styles = {
    action: { backgroundColor: alpha(theme.palette.grey[100], 0.2), color: theme.palette.text.secondary },
    operation: { backgroundColor: alpha(theme.palette.grey[100], 0.2), color: theme.palette.text.secondary },
    done: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      fontWeight: 600,
      borderRadius: 0
    },
    default: { backgroundColor: theme.palette.common.white, color: theme.palette.text.primary }
  };

  return {
    borderRadius: 0,
    textTransform: 'none',
    fontSize: '1.25rem',
    transition: 'none', // Remove all transitions for instant response
    boxShadow: 'none',
    border: `1px solid ${alpha(theme.palette.divider, 0.4)}`,
    minWidth: 'unset',
    padding: 0,
    // Disable all hover/focus effects for faster interaction
    '&:hover': {
      backgroundColor: 'inherit',
      boxShadow: 'none',
    },
    '&:focus': {
      backgroundColor: 'inherit',
      boxShadow: 'none',
      outline: 'none',
    },
    '&:active': { 
      boxShadow: 'none',
      opacity: 0.7, // Simple opacity change for instant feedback
    },
    // Prevent text selection and improve touch performance
    userSelect: 'none',
    WebkitUserSelect: 'none',
    WebkitTouchCallout: 'none',
    WebkitTapHighlightColor: 'transparent',
    touchAction: 'manipulation',
    ...styles[buttonType],
  };
});

export const DragHandle = styled(Box)(({ theme }) => ({
  width: 48,
  height: 4,
  backgroundColor: theme.palette.grey[300],
  borderRadius: 2,
  margin: '12px auto 8px',
})); 